var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_c('v-col',[_c('textFieldForm',{attrs:{"valueInput":_vm.values.name,"rule":_vm.rules.name,"label":"Nombre","errorMessages":_vm.serverErrors.name},on:{"valueChange":(v) => {_vm.values.name = v.trim(); delete _vm.serverErrors.name}}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }